import { PropsWithChildren } from 'react';
import { PermissionProps } from '../../../types';

export interface WidgetProps {
  permissions?: PermissionProps;
  placement: 'top' | 'right' | 'center';
}

export const Widget = ({ children }: WidgetProps & PropsWithChildren) => <>{children}</>;
